module.exports = __webpack_public_path__ + "img/North Carolina.76105954.png";